import React, { useEffect, useLayoutEffect, useState } from "react";
import { Button, CardDeck, Form, FormControl, Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import logger from "../../../../utils/logger";
import {
  getKeyResources,
  loadKeyResources,
  loadPins,
  markPin,
  pinsLength,
} from "../../../controller/reducer/keyResources";
import { getLoading } from "../../../controller/reducer/ui";
import KeyResourceAddModal from "./add";
import KeyResourceCard from "./card";
import "./styles.css";

function check(title, search) {
  if (!title) return false;
  return title.toLowerCase().includes(search);
}

const meta = (
  <Helmet>
    <title>{`CR21 | Important Links`}</title>
    <meta
      name="description"
      content={"Important Pan-India key Covid resources"}
    />
  </Helmet>
);

function KeyResources() {
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState("");

  const dispatch = useDispatch();
  const _resources = useSelector(getKeyResources);
  const pinsCount = useSelector(pinsLength);
  const [resources, setResources] = useState(_resources);
  logger()(_resources);

  useLayoutEffect(() => {
    dispatch(loadPins());
  }, [dispatch]);

  const handlePin = (id, value) => {
    logger()(id, value);
    dispatch(markPin({ id, value }));
    if (value === true && pinsCount < 3) {
      //scroll to Top
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  };

  useEffect(() => {
    setResources(_resources.filter((res) => check(res.title, search)));
    logger()(resources);
  }, [_resources, search]);

  useEffect(() => {
    dispatch(loadKeyResources());
  }, [dispatch]);

  if (useSelector(getLoading))
    return (
      <Spinner
        style={{ position: "fixed", top: "50%", right: "47%" }}
        animation="border"
      >
        {" "}
        {meta}
      </Spinner>
    );

  return (
    <div>
      {meta}
      <Form inline className="ml-4 mr-4 mt-4" type="submit">
        <FormControl
          type="text"
          placeholder="Search"
          className="flex-grow-1"
          value={search}
          onChange={(e) => setSearch(e.currentTarget.value.toLowerCase())}
        />
      </Form>
      <Form.Text className="text-muted ml-4">
        Add Resources using <span className="fabx-icon">+</span>
        {" &"} Edit Resources using{" "}
        <Button
          size="sm"
          style={{
            background: "#ffa500",
            color: "black",
            border: "none",
            fontSize: "10px",
            fontWeight: "500",
          }}
          disabled
        >
          EDIT
        </Button>
      </Form.Text>
      {resources.length > 0 ? (
        <CardDeck className="m-4 justify-content-between">
          {resources.map((res, id) => (
            <KeyResourceCard
              dispatch={dispatch}
              key={id}
              res={res}
              onPin={handlePin}
            />
          ))}
        </CardDeck>
      ) : (
        <p className="ml-4 mr-4 mt-4 font-weight-normal">No Resources Found</p>
      )}
      <KeyResourceAddModal
        dispatch={dispatch}
        show={show}
        onClose={() => setShow(false)}
      />
      <div className="fabx" onClick={() => setShow(true)}>
        +
      </div>
    </div>
  );
}

export default KeyResources;
